import { useSearch } from "@tanstack/react-router";

export const useIsIframeEmbed = () => {
  const searchParams = useSearch({ strict: false });

  return "iframe" in searchParams && !!searchParams.iframe;
};
